import { type ReactNode } from 'react';
import CTATel from '../../CTATel/CTATel';
import Mask from '../../Mask/Mask';
import {
  StyledFooterRetailerContact,
  StyledFooterRetailerCtas,
  StyledFooterRetailerPerson,
} from './FooterRetailer.styles';

import {
  DesignTokenSizeEnum,
  Text,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { useTribalContext } from '@/context/tribal';
import Box from '../../Box/Box';
import CTAMail from '../../CTAMail/CTAMail';
import {
  performVWBasicDealerButtonClick,
  performVWBasicLinkClick,
} from '@/analytics/events';
import useGlobalStore, {
  GlobalStoreStateConfiguration,
} from '@/stores/globalStore';
import { SectionNames } from '@/analytics/sectionNames';
import { getActiveConfiguration } from '@/modules/utils/storeUtils';
import { useLocation } from 'react-router-dom';

interface FooterRetailerContactProps {
  img: ReactNode;
  name?: string;
  role: string;
  tel?: string;
  email?: string;
}

const FooterRetailerContact = ({
  img,
  name,
  role,
  tel,
  email,
}: FooterRetailerContactProps) => {
  const { contentManager, analyticsBuilder, analyticsManager } =
    useTribalContext();
  const { configurations, retailers } = useGlobalStore((state) => state.app);
  const { app } = useGlobalStore();
  const activeConfiguration: GlobalStoreStateConfiguration | undefined =
    getActiveConfiguration(app);
  const location = useLocation();


  const contactSalesRepresentativeCtaAnalyticsFn = () =>
    performVWBasicLinkClick({
      label: contentManager.get('ctas-email-rep'),
      sectionName: SectionNames.FOOTER,
      ...(location.pathname.includes('compare') && { configurations }),
      ...(!(location.pathname.includes('compare')) && { configuration: activeConfiguration }),
      retailers,
      analyticsManager,
      analyticsBuilder,
    });

  const telAnalyticsFn = () =>
    performVWBasicDealerButtonClick({
      label: `${tel}`,
      sectionName: SectionNames.FOOTER,
      ...(location.pathname.includes('compare') && { configurations }),
      ...(!(location.pathname.includes('compare')) && { configuration: activeConfiguration }),
      retailers,
      analyticsManager,
      analyticsBuilder,
    });

  return (
    <StyledFooterRetailerContact>
      <StyledFooterRetailerPerson>
        <Box as={Mask} size="extraSmall" mb={DesignTokenSizeEnum.static250}>
          {img}
        </Box>
        <Text tag={TextTag.div} bold>
          {role}
        </Text>
        <div>{name}</div>
      </StyledFooterRetailerPerson>
      <StyledFooterRetailerCtas>
        {tel && (
          <Box mb={DesignTokenSizeEnum.static350}>
            <CTATel tel={tel} onClick={telAnalyticsFn} />
          </Box>
        )}
        {email && (
          <CTAMail
            ctaProps={{ emphasis: 'tertiary' }}
            mailto={email}
            onClick={contactSalesRepresentativeCtaAnalyticsFn}
          >
            {contentManager.get('ctas-email-rep')}
          </CTAMail>
        )}
      </StyledFooterRetailerCtas>
    </StyledFooterRetailerContact>
  );
};

export default FooterRetailerContact;
